import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

// Default fallback while the API is loading. Keeps first-paint clean.
const FALLBACK = {
  cohort_label: "Term 4, 2026 cohort",
  duration: "6 workshops × 2 hours · 12 hours contact",
  delivery: "Hybrid (in-person & online)",
  start_label: "Mid-October · Term 4",
  eligibility: "Teacher aides supporting ELL students in NZ schools",
  stat1_number: "Level 4",
  stat1_label: "NZQA · 5 Credits",
  stat2_number: "6 × 2 hrs",
  stat2_label: "Six workshops · hybrid",
  stat3_number: "Term 4",
  stat3_label: "Starting mid-October",
  padma_role: "Founder · Accredited Ministry of Education PLD Facilitator",
  padma_bio: "",
  contact_email: "pkrishnan3@gmail.com",
  contact_phone: "021 169 7833",
  contact_phone_href: "+64211697833",
  contact_linkedin: "https://www.linkedin.com/in/padma-krishnan-75206446",
  contact_location: "Padma Krishnan · Auckland, Aotearoa NZ",
};

export function useSiteContent() {
  const q = useQuery({
    queryKey: ["site-content"],
    queryFn: () => api.get("/content").then((r) => r.data),
    staleTime: 60_000,
  });
  return q.data || FALLBACK;
}
